module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-react-helmet-async@1.2.3_gatsby@5.16.1_babel-eslint@10.1.0_eslint@7.32.0__096dafe0bbdc5cdaab998590a2e7fa0f/node_modules/gatsby-plugin-react-helmet-async/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-nprogress@5.16.0_gatsby@5.16.1_babel-eslint@10.1.0_eslint@7.32.0__esbuild_7f29364353f196d5b5de6ab4958c151d/node_modules/gatsby-plugin-nprogress/gatsby-browser.js'),
      options: {"plugins":[],"color":"#ead486","showSpinner":true},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.16.1_babel-eslint@10.1.0_eslint@7.32.0__esbuild@0.17.19_react-dom@18.3.1_react_cf01f15fe165977b006dba2848f8c4a6/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
